// extracted by mini-css-extract-plugin
export default {"dropdown":"select_dropdown__j8RJ6","open":"select_open__eyYsI","dropdown__select":"select_dropdown__select__fA+8u"};